<template lang="pug">
	.items-dropdown.dropdown-menu.dropdown-menu-right(v-if="showed" :style="position" v-pseudo-modal-name="'items-dropdown'")
		.dropdown-header.text-center(v-if="options.title")
			strong {{options.title}}
		.dropdown-scrollable(v-bar :style="scrollableStyle")
			.dropdown-items(:style="{height: `${this.options.height || 400}px`}")
				.dropdown-item(v-for="item in items" @click="choose(item.name)" :class="item.className")
					.item-title(:style="{'fontWeight': item.mandatory ? 'bold' : 'normal'}") {{item.title || item.name}}
					.item-description.text-muted(:style="{'fontWeight': item.mandatory ? 'bold' : 'normal'}") {{item.description}}
</template>

<script>
	import Screen 				from './../../mixins/screen'

	export default {
		name: "CreativeEventsMenu",
		mixins: [Screen],
		screen: {
			events: {
				"Show ItemsDropdown": function(el, items, options, callback) {

					this.items = items || [];
					this.options = options || {};
					this.callback = callback;

					this.show();

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right + rect.width + 5) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

				},
				//Клик в любом месте кроме контента помеченного items-dropdown - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'items-dropdown') && this.showed) this.hide();

				}
			}
		},
		data() {

			this.items = [];

			this.callback = () => {};

			return {
				showed: false,
				position: {
					right: 0,
					bottom: 0
				}
			};
		},
		computed: {
			scrollableStyle() {

				let items_height = this.items.length * 42;
				let container_height = this.options.height || 400;

				if (items_height < container_height) return {maxHeight: container_height + 'px'};
				else return {height: container_height + 'px'};

			}
		},
		methods: {
			collectData() {

			},
			choose(event_name) {

				this.hide();

				this.callback(event_name);

			}
		}
	}
</script>

<style lang="sass">

	.items-dropdown.dropdown-menu
		top: auto
		bottom: 10px
		right: 100px
		width: 250px

		.dropdown-scrollable
			height: auto

			.dropdown-item
				width: calc(100% + 20px)

				.item-title

				.item-description
					white-space: normal
					line-height: 12px
					font-size: 11px
</style>

